import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }
  }
};

export const BentoSection = () => {
  const solutions = [
    {
      id: 'energioptimering',
      title: 'Energioptimering',
      description: 'Udskiftning og optimering af belysningsinstallationer i erhvervsbygninger. Vi analyserer eksisterende installationer og implementerer energieffektive LED-løsninger med fokus på lavere energiforbrug, bedre lysforhold og dokumenterbar effekt.',
      image: '/images/film-grabs/still-1.jpg',
      href: '/ydelser/energioptimering',
    },
    {
      id: 'lysstyring',
      title: 'Intelligent lysstyring',
      description: 'Sensorer, zonestyring og automatisering tilpasser belysningen efter aktivitet, dagslys og anvendelse af bygningen. Reducerer energispild og giver større kontrol over energiforbrug og drift.',
      image: '/images/film-grabs/still-3.jpg',
      href: '/ydelser/lysstyring',
    },
  ];

  return (
    <section 
      data-testid="bento-section" 
      className="bg-[#F4F2EE]"
    >
      {/* Full-width Bento Grid - Edge to edge */}
      <motion.div 
        className="grid grid-cols-1 md:grid-cols-2 gap-1"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={containerVariants}
      >
        {solutions.map((solution) => (
          <motion.div
            key={solution.id}
            variants={itemVariants}
            data-testid={`bento-card-${solution.id}`}
          >
            <Link 
              to={solution.href}
              className="group block relative aspect-[16/10] md:aspect-[4/3] lg:aspect-[16/9] overflow-hidden"
            >
                {/* Image */}
                <motion.img 
                  src={solution.image} 
                  alt={solution.title}
                  className="w-full h-full object-cover"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
                />
                
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
                
                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <h3 className="text-white text-2xl md:text-3xl font-medium mb-2">
                    {solution.title}
                  </h3>
                  <p className="text-white/70 text-sm leading-relaxed max-w-md">
                    {solution.description}
                  </p>
                </div>

                {/* Arrow */}
                <div className="absolute top-6 right-6">
                  <ArrowRight 
                    size={24} 
                    className="text-white/50 group-hover:text-white group-hover:translate-x-1 transition-all duration-300" 
                  />
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
    </section>
  );
};
